import * as React from 'react';
import { MemberStatementDetailsGrid } from '../statementDetailsGrid/MemberStatementDetailsGrid';
import { MemberStatementPaymentSummaryGrid } from '../statementDetailsGrid/MemberStatementPaymentSummaryGrid';
import { IMemberStatementDistributionPool, IMemberStatementSearchResult } from '../../../types/IMemberStatementSearchResult';
import IMembersPortalComponentDataItem from '../../../../redux/types/IMembersPortalComponentDataItem';
import { mp_addTab } from '../../../../redux/reducers/MembersPortalReducer';
import { MembersPortalService } from '../../../../redux/services/MembersPortalService';
import Loader from '../../../../repertoire/components/loader/Loader';

export interface IMemberStatementDetailsPageProps {
    payment?: IMemberStatementSearchResult;
    paymentDetailPageComponentData: IMembersPortalComponentDataItem;
    paymentDetailGridsComponentData: IMembersPortalComponentDataItem;
    paymentSummaryGridsComponentData: IMembersPortalComponentDataItem;
    addTab: typeof mp_addTab;
    userNameNumber: string;
    refreshKey?: number;
}

export const MemberStatementDetailsPage: React.FC<IMemberStatementDetailsPageProps> = (props: IMemberStatementDetailsPageProps) => {
    const [viewData, setViewData] = React.useState({});

    React.useEffect(() => {
        const {
            paymentDetailPageComponentData: { fields }
        } = props;
        let data = {}
        if (fields) {
            const visibleFields = fields.filter(field => !field.hidden);

            visibleFields.forEach(item => {
                data[item.name] = item.data;

                if (Object.keys(data).length === visibleFields.length) {
                    setViewData(data);
                }
            });
        }
    }, [])

    if (props.payment) {
        const { paymentRunCode, description, paymentRunID } = props.payment;

        return (
            <div>
                <div><span className="title">{viewData['payment']} {paymentRunCode}</span></div>

                    <MemberStatementPaymentSummaryGrid
                        payment={props.payment}
                        paymentRunID={paymentRunID}
                        refreshKey={props.refreshKey}
                        paymentSummaryGridsComponentData={props.paymentSummaryGridsComponentData}
                    />

                <br />
                <div><span className='subtitle'>{viewData['statementBy']}</span></div>

                <div>
                    <MemberStatementDetailsGrid
                        paymentRunCode={paymentRunCode}
                        paymentRunID={paymentRunID}
                        description={description}
                        paymentDetailGridsComponentData={props.paymentDetailGridsComponentData}
                        addTab={props.addTab}
                        userNameNumber={props.userNameNumber}
                        refreshKey={props.refreshKey}
                    />
                </div>
            </div>
        )
    }
    else
        return <div></div>

}